import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import './GoLiveStep.css';
import golive_arrow from '../../../../Assets/icons/golive_arrow.png';

export interface GoLiveStepProps {
    heading: string,
    icon?: string,
    body: JSX.Element,
    arrow?: boolean
}

export const GoLiveStep = (props: GoLiveStepProps) => {
    const {heading, icon, body, arrow} = props;

    return (
        <>
            <Grid item xs={12} md={12} className='goLiveStep_container'>
                <Box className="goLiveStep_box">
                    <img src={icon} className="goLiveStep_icon" alt=""/>
                    <div className="goLiveStep_boxContainerWithArrow">
                        <Typography className = "goLiveStep_heading ">{heading}</Typography>
                        <Typography variant="h5" className = "goLiveStep_body ">{body}</Typography>
                    </div>
                </Box>
            </Grid>
            {(arrow === false)?<></>:
                            <img src={golive_arrow} className="goLiveStep_arrow" alt=""/>  
            }
        </>
    );
}
